import {eq} from '@shared/helpers/lang'

import {FAILED_RESULT_CODE} from '@web/core/constants'

import {RootState} from '../interfaces'

export const subscribeSelector = (state: RootState) => state.subscribe

export const subscribeFailedReasonSelector = (state: RootState) => {
    const eqFailedReason = eq(state.subscribe.failedReason)

    return {
        isExpiredOrderSheet: eqFailedReason(FAILED_RESULT_CODE.EXPIRED_ORDER_SHEET),
        isOrderSheetError: eqFailedReason(FAILED_RESULT_CODE.ORDER_SHEET_ERROR),
        isUnExpectedError: eqFailedReason(FAILED_RESULT_CODE.UNKNOWN),
    }
}
